import coreStore from "./core-store";
const remoteResource = 'auth/api/v1/security-groups';

const store = coreStore.createCoreStore('securityGroup', remoteResource);

export default store;